import { ActionTree } from 'vuex';
import axios from 'axios';
import { RootState } from '@/store/types';
import { MessageTypeFilter, MessageTypeItem, MessageTypesState } from './types';

export const actions: ActionTree<MessageTypesState, RootState> = {
  getMessageTypes: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
      axios({ url: '/lk-api/message-types', params: data })
        .then(resp => {
          commit('setMessageTypes', resp.data);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getMessageTypeItem: ({ commit }, id) => {
    return new Promise((resolve, reject) => {
      axios({ url: `/message_types/${id}` })
        .then((resp: any) => {
          let messageTypeItem = <MessageTypeItem>resp.data;
          messageTypeItem.id = id;
          commit('setMessageTypeItem', messageTypeItem);
          resolve(messageTypeItem)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  saveMessageTypeItem: ({ commit, dispatch }, data: MessageTypeItem) => {
    return new Promise((resolve, reject) => {
      axios({
        method: data.id ? 'put' : 'post',
        url: '/message_types/' + (data.id ?? ''),
        data: data
      })
        .then((resp: any) => {
          dispatch('getMessageTypes');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
    })
  },
  deleteMessageTypeItem: ({ commit, dispatch }, data: MessageTypeItem) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/message_types/${data.id}`,
        data: data
      })
        .then((resp: any) => {
          dispatch('getMessageTypes');
          resolve(resp)
        })
        .catch((err: any) => {
          reject(err)
        })
    })
  },
};